module.exports = __webpack_public_path__ + "static/media/carplay.5e086c03.jpg";